var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgProductLink = function SvgProductLink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.77 11.95C11.725 11.95 11.68 11.935 11.65 11.905C11.575 11.83 11.575 11.725 11.65 11.65C12.19 11.11 12.49 10.39 12.49 9.64001C12.49 8.06501 11.215 6.79001 9.63999 6.79001C8.06499 6.79001 6.78999 8.06501 6.78999 9.64001C6.78999 9.73001 6.71499 9.82001 6.60999 9.82001C6.50499 9.82001 6.42999 9.74501 6.42999 9.64001C6.42999 7.87001 7.86999 6.44501 9.62499 6.44501C11.395 6.44501 12.82 7.88501 12.82 9.64001C12.82 10.495 12.49 11.305 11.89 11.905C11.86 11.935 11.815 11.95 11.77 11.95Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63998 12.835C8.28998 12.835 7.07498 11.98 6.62498 10.705C6.59498 10.615 6.63998 10.51 6.72998 10.48C6.81998 10.45 6.92498 10.495 6.95498 10.585C7.35998 11.725 8.43998 12.49 9.63998 12.49C10.06 12.49 10.48 12.4 10.855 12.22C10.945 12.175 11.05 12.22 11.095 12.31C11.14 12.4 11.095 12.505 11.005 12.55C10.57 12.73 10.105 12.835 9.63998 12.835Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64001 4.735C8.60501 4.735 7.76501 3.895 7.76501 2.86C7.76501 1.825 8.60501 1 9.64001 1C10.66 1 11.5 1.84 11.5 2.875C11.5 3.91 10.66 4.735 9.64001 4.735ZM9.64001 1.345C8.80001 1.345 8.12501 2.02 8.12501 2.86C8.12501 3.7 8.80001 4.375 9.64001 4.375C10.48 4.375 11.155 3.7 11.155 2.86C11.155 2.035 10.465 1.345 9.64001 1.345Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.875 11.5C1.84 11.5 1 10.66 1 9.63998C1 8.60498 1.84 7.76498 2.875 7.76498C3.91 7.76498 4.75 8.60498 4.75 9.63998C4.735 10.66 3.895 11.5 2.875 11.5ZM2.875 8.10998C2.035 8.10998 1.345 8.79998 1.345 9.63998C1.345 10.48 2.02 11.155 2.86 11.155C3.7 11.155 4.375 10.48 4.375 9.63998C4.39 8.79998 3.7 8.10998 2.875 8.10998Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64002 6.79C9.55002 6.79 9.46002 6.715 9.46002 6.61V4.555C9.46002 4.465 9.53502 4.375 9.64002 4.375C9.73002 4.375 9.82002 4.45 9.82002 4.555V6.61C9.80502 6.7 9.73002 6.79 9.64002 6.79Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.675 9.80501H4.555C4.465 9.80501 4.375 9.73001 4.375 9.62501C4.375 9.53501 4.45 9.44501 4.555 9.44501H7.66C7.75 9.44501 7.84 9.52001 7.84 9.62501C7.84 9.73001 7.765 9.80501 7.675 9.80501Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.125 16C13.09 16 12.25 15.16 12.25 14.125C12.25 13.09 13.09 12.25 14.125 12.25C15.16 12.25 16 13.09 16 14.125C16 15.16 15.16 16 14.125 16ZM14.125 12.61C13.285 12.61 12.61 13.285 12.61 14.125C12.61 14.965 13.285 15.64 14.125 15.64C14.965 15.64 15.64 14.965 15.64 14.125C15.655 13.3 14.965 12.61 14.125 12.61Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.94 13.105C12.895 13.105 12.85 13.09 12.82 13.06L11.65 11.89C11.575 11.815 11.575 11.71 11.65 11.635C11.725 11.56 11.83 11.56 11.905 11.635L13.075 12.805C13.15 12.88 13.15 12.985 13.075 13.06C13.03 13.09 12.985 13.105 12.94 13.105Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProductLink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/product-link.391539f6.svg";
export { ForwardRef as ReactComponent };